import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppStateService } from '../services/app-state.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  const appState = inject(AppStateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Auto logout if 401 response returned from API
        appState.clearAuthData();
        
        router.navigate(['/auth/login']);
        snackBar.open('Su sesión ha expirado, por favor inicie sesión nuevamente', 'Cerrar', {
          duration: 5000
        });
      } else if (error.status === 403) {
        snackBar.open('No tiene permisos para realizar esta acción', 'Cerrar', {
          duration: 5000
        });
      } else if (error.status === 400) {
        const errorMessage = error.error?.message || 'Datos incorrectos, por favor verifique';
        snackBar.open(errorMessage, 'Cerrar', {
          duration: 5000
        });
      } else if (error.status === 404) {
        snackBar.open('Recurso no encontrado', 'Cerrar', {
          duration: 5000
        });
      } else if (error.status === 409) {
        snackBar.open(error.error?.message || 'El recurso ya existe', 'Cerrar', {
          duration: 5000
        });
      } else if (error.status === 0) {
        snackBar.open('No se pudo conectar con el servidor. Por favor verifique su conexión', 'Cerrar', {
          duration: 5000
        });
      } else {
        snackBar.open('Ha ocurrido un error inesperado', 'Cerrar', {
          duration: 5000
        });
      }
      
      return throwError(() => error);
    })
  );
};
